export default __webpack_public_path__ + "static/it-ee92222dc474b596293aae9fe6cb1e8a.svg";